import { Loader2, Plus } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import Table, { createColumnHelper } from '../../Common/components/Table';
import useUserOrg from '../../Authentication/components/hooks/useUserOrg';
import { useDeviceGroupList } from './hooks/useDeviceGroupList';
import { Button } from '@/src/shadComponents/ui/button';

const columnHelper = createColumnHelper<DeviceGroupWithKeys>();

export default function DeviceGroups() {
    const { orgId } = useUserOrg();
    const { deviceGroups, isLoading } = useDeviceGroupList(orgId);

    const columnDefinitions = [
        columnHelper.accessor('name', {
            id: 'name',
            header: () => <span>Name</span>,
            cell: (info) => (
                <span>
                    <NavLink
                        to={`device-groups/${info.row.original.id}/device-keys`}
                    >
                        {info.getValue()}
                    </NavLink>
                </span>
            ),
        }),
        columnHelper.display({
            id: 'deviceCount',
            header: () => <span>Devices</span>,
            cell: (props: { row: { original: DeviceGroupWithKeys } }) => (
                <span>
                    <NavLink
                        to={`device-groups/${props.row.original.id}/device-keys`}
                    >
                        {props.row.original.devices.length}
                    </NavLink>
                </span>
            ),
        }),
        columnHelper.display({
            id: 'unclaimedInviteCount',
            header: () => <span>Invited</span>,
            cell: (props: { row: { original: DeviceGroupWithKeys } }) => (
                <span>
                    <NavLink
                        to={`device-groups/${props.row.original.id}/invites`}
                    >
                        {props.row.original.invites.length}
                    </NavLink>
                </span>
            ),
        }),
        columnHelper.display({
            id: 'actions',
            cell: (props: { row: any }) => null,
        }),
    ];

    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-12">
                <Loader2 className="size-6 animate-spin text-muted-foreground" />
            </div>
        );
    }

    return (
        <div>
            <div className="flex items-center mx-8 mb-6">
                <h2 className="text-lg font-semibold tracking-tight text-foreground">
                    Groups
                </h2>
                <div className="flex-1" />
                <div className="flex items-center gap-2">
                    <NavLink to="device-groups/create">
                        <Button>
                            <Plus className="size-4" />
                            Create Device Group
                        </Button>
                    </NavLink>
                    <NavLink to="device-invites/create">
                        <Button variant="outline">
                            <Plus className="size-4" />
                            Invite Device
                        </Button>
                    </NavLink>
                </div>
            </div>
            <Table data={deviceGroups} columns={columnDefinitions} />
        </div>
    );
}
